module.exports = __webpack_public_path__ + "static/media/nadvori.a9e4f771.jpg";